var _rect, _path, _path2, _path3, _circle, _circle2, _rect2, _rect3, _rect4, _polygon, _polygon2, _polygon3, _rect5, _rect6, _rect7, _rect8, _circle3, _circle4, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    id: "shipping",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 216,
    x: 24,
    y: 120,
    fill: "#E65C79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D7597",
    d: "M482.979,250.143l-36.737-42.86c-3.962-4.622-9.746-7.282-15.834-7.282H338c-5.523,0-10,4.477-10,10v118H24 v32h312v-0.201c0.646,0.131,1.315,0.201,2,0.201h140c5.523,0,10-4.477,10-10v-86.285C488,258.736,486.219,253.922,482.979,250.143z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#59ACDE",
    d: "M430.408,200H384v72h104v-8.285c0-4.978-1.781-9.792-5.021-13.572l-36.737-42.86 C442.28,202.66,436.496,200,430.408,200z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2D061",
    d: "M488,328h-25.203c-3.754,0-6.797-3.043-6.797-6.797v-18.406c0-3.754,3.043-6.797,6.797-6.797H488V328z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 360,
    r: 40,
    fill: "#213F52"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 360,
    r: 16,
    fill: "#F2D061"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 80,
    x: 200,
    y: 248,
    fill: "#D3A04C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 80,
    x: 200,
    y: 168,
    fill: "#EAB254"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 80,
    x: 104,
    y: 248,
    fill: "#EAB254"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#AE465C",
    points: "264 280 248 272 232 280 232 248 264 248"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#AE465C",
    points: "168 280 152 272 136 280 136 248 168 248"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#AE465C",
    points: "264 200 248 192 232 200 232 168 264 168"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 152,
    y: 200,
    fill: "#D3A04C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 152,
    y: 152,
    fill: "#F9BD59"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 56,
    y: 232,
    fill: "#B48941"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 56,
    y: 280,
    fill: "#D3A04C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 360,
    r: 40,
    fill: "#213F52"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 360,
    r: 16,
    fill: "#F2D061"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M489.054,244.937L489.054,244.937l-36.737-42.86C446.828,195.673,438.843,192,430.408,192H338 c-0.677,0-1.342,0.045-2,0.118V120c0-4.418-3.582-8-8-8H24c-4.418,0-8,3.582-8,8v240c0,4.418,3.582,8,8,8h48.679 c3.821,22.671,23.58,40,47.321,40s43.499-17.329,47.321-40h177.359c3.821,22.671,23.58,40,47.321,40s43.499-17.329,47.321-40H478 c9.925,0,18-8.075,18-18v-86.285C496,256.832,493.533,250.163,489.054,244.937z M32,128h288v192h-16V168c0-4.418-3.582-8-8-8h-88 v-8c0-4.418-3.582-8-8-8h-48c-4.418,0-8,3.582-8,8v48v40h-32v-8c0-4.418-3.582-8-8-8H56c-4.418,0-8,3.582-8,8v88H32V128z  M227.794,286.805c2.359,1.457,5.304,1.59,7.784,0.35L248,280.944l12.422,6.211C261.551,287.72,262.777,288,264,288 c1.463,0,2.922-0.401,4.207-1.195c2.358-1.458,3.794-4.033,3.794-6.805v-24h16v64h-80v-64h16v24 C224,282.772,225.436,285.348,227.794,286.805z M240,267.056V256h16v11.056l-4.422-2.211C250.452,264.282,249.226,264,248,264 s-2.452,0.282-3.578,0.845L240,267.056z M208,240v-40v-24h16v24c0,2.772,1.436,5.348,3.794,6.805 c2.359,1.457,5.304,1.59,7.784,0.35L248,200.944l12.422,6.211C261.551,207.72,262.777,208,264,208c1.463,0,2.922-0.401,4.207-1.195 c2.358-1.458,3.794-4.033,3.794-6.805v-24h16v64H208z M240,187.056V176h16v11.056l-4.422-2.211 C250.452,184.282,249.226,184,248,184s-2.452,0.282-3.578,0.845L240,187.056z M160,192v-32h32v32H160z M192,208v32h-32v-32H192z  M160,256v11.056l-4.422-2.211C154.452,264.282,153.226,264,152,264s-2.452,0.282-3.578,0.845L144,267.056V256H160z M96,240v32H64 v-32H96z M72.679,352H32v-16h46.458C75.638,340.862,73.647,346.258,72.679,352z M64,320v-32h32v30.458 c-0.847,0.491-1.68,1.002-2.493,1.542H64z M120,392c-17.645,0-32-14.355-32-32s14.355-32,32-32s32,14.355,32,32 S137.645,392,120,392z M146.493,320c-7.598-5.049-16.706-8-26.493-8c-2.726,0-5.396,0.24-8,0.679V256h16v24 c0,2.772,1.436,5.348,3.794,6.805c2.359,1.457,5.304,1.59,7.784,0.35L152,280.944l12.422,6.211C165.551,287.72,166.777,288,168,288 c1.463,0,2.922-0.401,4.207-1.195c2.358-1.458,3.794-4.033,3.794-6.805v-24h16v64H146.493z M392,392c-17.645,0-32-14.355-32-32 s14.355-32,32-32s32,14.355,32,32S409.645,392,392,392z M480,320h-16v-16h16V320z M480,288h-17.203 c-8.159,0-14.797,6.638-14.797,14.797v18.406c0,8.159,6.638,14.797,14.797,14.797H480v14c0,1.103-0.897,2-2,2h-38.679 c-3.821-22.671-23.58-40-47.321-40s-43.499,17.329-47.321,40H167.321c-0.968-5.742-2.958-11.138-5.778-16H328c4.418,0,8-3.582,8-8 V210c0-1.103,0.897-2,2-2h38v64c0,4.418,3.582,8,8,8h96V288z M480,264h-88v-56h38.408c3.757,0,7.315,1.636,9.76,4.489 l36.737,42.859c1.996,2.329,3.095,5.299,3.095,8.366V264z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M392 336c-13.234 0-24 10.766-24 24s10.766 24 24 24 24-10.766 24-24S405.234 336 392 336zM392 368c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8S396.411 368 392 368zM120 336c-13.234 0-24 10.766-24 24s10.766 24 24 24 24-10.766 24-24S133.234 336 120 336zM120 368c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8S124.411 368 120 368z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.9671eac2d6cb6812e535607606d86a24.svg";
export { ForwardRef as ReactComponent };